import {COMPLIANCE_OPTIONS, type ComplianceCodeName} from 'bigdatr-style';

export const complianceShortlistQueryKeys = {
    lists: (complianceCodeId: string) => ['compliance-shortlists', complianceCodeId] as const,
    creatives: (complianceCodeId: string, shortList: string) =>
        ['compliance-shortlist-creatives', complianceCodeId, shortList] as const,
    creative: (complianceCodeId: string, creativeId: string) =>
        ['compliance-shortlist-creative', complianceCodeId, creativeId] as const
};

export function resolveComplianceCode(
    complianceCode: string | undefined,
    permitted: readonly ComplianceCodeName[]
): ComplianceCodeName {
    const fallback = permitted[0] ?? COMPLIANCE_OPTIONS[0];
    return permitted.find((option) => option === complianceCode) ?? fallback;
}
